var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.purchase.actions.supplier.supplementary_agreement === "sign"
    ? _c(
        "div",
        [
          _c("fl44-contract-supplier-sign-supplementary-agreement-button", {
            staticClass: "mb-3",
            attrs: {
              "supplementary-agreement": _vm.supplementaryAgreement,
              purchase: _vm.purchase,
            },
            on: {
              refresh: function ($event) {
                return _vm.$emit("refresh")
              },
            },
          }),
          _vm.purchase.actions.supplier
            .can_store_supplementary_agreement_disagreement
            ? [
                _c("form-row-single-line-document-upload", {
                  attrs: {
                    "label-cols-lg": 3,
                    title: "Протокол разногласий",
                    v: _vm.$v.form.disagreement,
                  },
                  model: {
                    value: _vm.form.disagreement,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "disagreement", $$v)
                    },
                    expression: "form.disagreement",
                  },
                }),
                _c("form-row-edit-textarea", {
                  attrs: { label: "Комментарий", v: _vm.$v.form.comment },
                  model: {
                    value: _vm.form.comment,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "comment",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.comment",
                  },
                }),
                _c(
                  "b-overlay",
                  {
                    attrs: {
                      show: _vm.isDataSending,
                      opacity: "0.6",
                      rounded: "",
                      "spinner-small": "",
                      "spinner-variant": "primary",
                    },
                  },
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "mr-2 mb-2",
                        attrs: {
                          disabled:
                            !_vm.$store.getters.getCanSign || _vm.$v.$invalid,
                          variant: "custom-green",
                        },
                        on: { click: _vm.showSignForm },
                      },
                      [_vm._v("Подписать и отправить протокол разногласий")]
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.getCanSign
                  ? [
                      _vm.$store.getters.getLoginType === "cert"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                            },
                            [
                              _vm._v(
                                " Для действия требуется загрузить/заменить МЧД на странице: "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticClass: "green-link",
                                  attrs: { to: { name: "CabinetUserProfile" } },
                                },
                                [_vm._v("Данные учетной записи")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                            },
                            [
                              _vm._v(
                                "Подписание возможно только при авторизации при помощи ЭЦП"
                              ),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _c(
                  "b-modal",
                  {
                    ref: "sign-form-modal",
                    attrs: {
                      centered: "",
                      "no-close-on-backdrop": "",
                      "no-close-on-esc": "",
                      scrollable: "",
                      size: "lg",
                      title: "Подписать протокол разногласий",
                    },
                    on: { close: _vm.cancelSignModal },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "modal-header-close",
                          fn: function () {
                            return [_c("button-close-modal")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1489420097
                    ),
                    model: {
                      value: _vm.showSignModal,
                      callback: function ($$v) {
                        _vm.showSignModal = $$v
                      },
                      expression: "showSignModal",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-block text-left" },
                      [
                        _c(
                          "b-tabs",
                          { attrs: { "content-class": "mt-3 px-3" } },
                          [
                            _c(
                              "b-tab",
                              {
                                attrs: { active: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "system_link-style fs-16",
                                            },
                                            [_vm._v("Протокол разногласий")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2809949153
                                ),
                              },
                              [
                                _c("text-row-single-document", {
                                  attrs: {
                                    compact: "",
                                    "label-cols-lg": 4,
                                    "label-cols-sm": 4,
                                    label: "Протокол разногласий",
                                    value: _vm.form.disagreement,
                                  },
                                }),
                                _c("text-row", {
                                  attrs: {
                                    compact: "",
                                    "label-cols-lg": 4,
                                    "label-cols-sm": 4,
                                    label: "Комментарий",
                                    value: _vm.form.comment,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-tab",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "system_link-style fs-16",
                                            },
                                            [_vm._v("XML")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  119620390
                                ),
                              },
                              [
                                !_vm.isSignedXml
                                  ? _c("b-form-textarea", {
                                      staticClass: "text-monospace fs-12",
                                      attrs: {
                                        disabled: "",
                                        rows: "20",
                                        "no-resize": "",
                                        "no-auto-shrink": "",
                                        wrap: "off",
                                      },
                                      model: {
                                        value: _vm.formXml,
                                        callback: function ($$v) {
                                          _vm.formXml = $$v
                                        },
                                        expression: "formXml",
                                      },
                                    })
                                  : _c("b-form-textarea", {
                                      staticClass: "text-monospace fs-12",
                                      attrs: {
                                        disabled: "",
                                        rows: "20",
                                        "no-resize": "",
                                        "no-auto-shrink": "",
                                        wrap: "off",
                                      },
                                      model: {
                                        value: _vm.signedFormXml,
                                        callback: function ($$v) {
                                          _vm.signedFormXml = $$v
                                        },
                                        expression: "signedFormXml",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "w-100 px-3",
                        attrs: { slot: "modal-footer" },
                        slot: "modal-footer",
                      },
                      [
                        _c("text-row", {
                          attrs: {
                            compact: "",
                            label: "Сертификат",
                            value: _vm.certificate?.subjectName,
                          },
                        }),
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-2 text-uppercase",
                            attrs: {
                              disabled: _vm.isDataSending,
                              variant: "custom-outline-secondary",
                            },
                            on: { click: _vm.cancelSignModal },
                          },
                          [_vm._v("Отмена")]
                        ),
                        !_vm.isSignedXml
                          ? _c(
                              "b-overlay",
                              {
                                staticClass: "d-inline-block",
                                attrs: {
                                  show: _vm.isSigningXml,
                                  opacity: "0.6",
                                  rounded: "",
                                  "spinner-small": "",
                                  "spinner-variant": "primary",
                                },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "text-uppercase",
                                    attrs: {
                                      disabled: !_vm.certificate,
                                      variant: "custom-green",
                                    },
                                    on: { click: _vm.signForm },
                                  },
                                  [_vm._v("Подписать")]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "b-overlay",
                              {
                                staticClass: "d-inline-block",
                                attrs: {
                                  show: _vm.isDataSending,
                                  opacity: "0.6",
                                  rounded: "",
                                  "spinner-small": "",
                                  "spinner-variant": "primary",
                                },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "text-uppercase",
                                    attrs: {
                                      disabled: !_vm.certificate,
                                      variant: "custom-green",
                                    },
                                    on: { click: _vm.storeSignedDisagreement },
                                  },
                                  [_vm._v("Отправить")]
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }